<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h14">A<span class="th14">CKNOWLEDGMENTS</span></h1>
<p class="p0"> </p>
<p class="p0"> </p>
<p class="p0">To the countless storytellers who’ve shown us </p>
<p class="p0">how the inner journey gives meaning to the outer;<span class="t5"> </span></p>
<p class="p0">to Dr. Grant Johnson for sharing his </p>
<p class="p0">expertise in Ericksonian hypnotherapy;</p>
<p class="p0">to my writing buddies whose insights made </p>
<p class="p0">this story so much better, especially</p>
<p class="p0">Martha Ragland and the rest of </p>
<p class="p0">my wonderful “Oregonian” critique circle; </p>
<p class="p0">and to my husband Bob, for his loving patience—</p>
<p class="p0">heartfelt thanks.</p>
<p class="p5"> </p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?5a3913e3